<template>
  <div class="codescreen">
    <div class="wrapper-section">
      <div class="codescreen__inner">
        <h2 class="codescreen__title pform__title pform__title_smspace">На Ваш номер отправлен&nbsp;код</h2>
        <p class="pform__subtitle codescreen__subtitle">Код отправлен на номер <b class="nowrap">{{ form.applicant.tel }}</b></p>
        <p class="codescreen__text">Если Ваш номер указан не верно, то Вы можете 
          <a @click.prevent="showPopup = true">изменить</a>
          его</p>
        <NumberInput :filled="(v)=>v.length == 4" mask="####" v-model="code" text="Введите код из SMS" name="code" />
        <p class="codescreen__timertext">Повторная отправка доступна через <b>{{ timerstring }}</b></p>
        <Btn class="codescreen__button" @click="$store.dispatch('sendAndFinish')" v-if="code.length == 4">Далее</Btn>
        <Btn class="codescreen__button" @click="$store.dispatch('sendCode')" :disabled="codeSeconds" v-else>Повторить</Btn>
      </div>
    </div>
  </div>
  <Popup v-model="showPopup">
    <h3 class="pfpopup__title">Введите номер мобильного&nbsp;телефона</h3>
    <NumberInput mask="+7 (###) ###-##-##" @setError="telError = $event" :filled="(v)=>v.length == 18" v-model="tel" text="Номер мобильного телефона" name="applicant-tel-change"/>
    <Btn @click="changeApplicantTel" class="pfpopup__btn" :disabled="telError || !form.applicant.tel">Подтвердить</Btn>
  </Popup>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Popup from '@/components/Popup.vue';
import NumberInput from './inputs/NumberInput.vue';
import Btn from './Btn.vue';
export default {
  data: ()=>({
    code: '',
    showPopup: false,
    tel: '',
    telError: '',
  }),
  computed: {
    ...mapGetters(['timerstring']),
    ...mapState(['form','codeSeconds'])
  },
  methods: {
    changeApplicantTel() {
      this.form.applicant.tel = this.tel
      this.showPopup = false
      this.$store.dispatch('sendCode')
    },
  },
  components: { Popup, NumberInput, Btn },
}
</script>

<style lang="sass" scoped>
.codescreen
  &__inner
    width: 604px
    max-width: 100%
    margin: 100px auto 0
  &__text
    font-size: 14px
    line-height: 1.12
    text-align: center
    margin-bottom: 64px
    a
      cursor: pointer
      color: colors.$newred
  &__timertext
    text-align: center
    margin-bottom: 64px
  &__button
    width: 328px
    max-width: 100%
    margin: 32px auto
  @include for-mob
    & &__subtitle
      font-size: 20px
    &__text
      width: 240px
      margin: 0 auto 32px
    &__timertext
      line-height: 1.3
</style>